module.exports = __webpack_public_path__ + "img/image44.6f72f358.jpg";